<template style="height:100%">
  <el-container>
    <el-header style="height: 20%; background: rgba(255, 255, 255, 1)">
      <div style="margin-top: 20px"><h3>预约咨询统计</h3></div>
      <el-row
        style="font-size: 28px; color: rgba(0, 136, 255, 1); text-align: center"
      >
        <el-col :sm="4"
          ><div class="">{{ AppointmentCount }}</div></el-col
        >
        <el-col :sm="4"
          ><div class="">{{ todayCount }}</div></el-col
        >
        <el-col :sm="4"
          ><div class="">{{ examineCount }}</div></el-col
        >
        <el-col :sm="4"
          ><div class="">{{ applycount }}</div></el-col
        >
        <el-col :sm="4"
          ><div class="">{{ passCount }}</div></el-col
        >
        <el-col :sm="4"
          ><div class="">{{ noPassCount }}</div></el-col
        >
      </el-row>
      <el-row
        style="
          text-align: center;
          font-size: 15px;
          color: rgba(40, 40, 40, 1);
          text-align: center;
          magin-bottom: 10px;
        "
      >
        <el-col :sm="4"><div class="">当前预约人次</div></el-col>
        <el-col :sm="4"><div class="">今日来访人次</div></el-col>
        <el-col :sm="4"><div class="">申请审批</div></el-col>
        <el-col :sm="4"><div class="">申请中</div></el-col>
        <el-col :sm="4"><div class="">已通过</div></el-col>
        <el-col :sm="4"><div class="">已拒绝</div></el-col>
      </el-row>
    </el-header>

    <el-main
      style="background: rgba(255, 255, 255, 1); margin-top: 15px"
      class="workingSchedule"
    >
      <el-row
        style="
          font-size: 18px;
          color: rgba(40, 40, 40, 1);
          text-align: center;
          magin-bottom: 15px;
        "
      >
        <div style="position: absolute">值班表</div>
        <div class="">{{ dateTimeNow }}</div>
      </el-row>
      <el-row
        class="timerow"
        style="
          font-size: 14px;
          color: rgba(40, 40, 40, 1);
          text-align: center;
          magin-bottom: 20px;
          margin: 10px 0px;
          background-color: rgb(235, 236, 237);
        "
      >
        <el-col :sm="3"><div class="">日期</div></el-col>
        <el-col :sm="3" :class="today == one ? 'checked' : ''"
          ><div @click="GetTodayProject(one,year ,month, one, 2)">
            {{ today == one ? "今天" : one }}
          </div></el-col
        >
        <el-col :sm="3" :class="today == two ? 'checked' : ''"
          ><div
            @click="GetTodayProject(one, year,month,two,1)"
            class=""
          >
            {{ two }}
          </div></el-col
        >
        <el-col :sm="3" :class="today == three ? 'checked' : ''"
          ><div
            @click="GetTodayProject(one, year, month ,three, 1)"
            class=""
          >
            {{ three }}
          </div></el-col
        >
        <el-col :sm="3" :class="today == four ? 'checked' : ''"
          ><div
            @click="GetTodayProject(one, year,month,four, 1)"
            class=""
          >
            {{ four }}
          </div></el-col
        >
        <el-col :sm="3" :class="today == five ? 'checked' : ''"
          ><div
            @click="GetTodayProject(one, year,month,five, 1)"
            class=""
          >
            {{ five }}
          </div></el-col
        >
        <el-col :sm="3" :class="today == six ? 'checked' : ''"
          ><div
            @click="GetTodayProject(one, year,month,six, 1)"
            class=""
          >
            {{ six }}
          </div></el-col
        >
        <el-col :sm="3" :class="today == seven ? 'checked' : ''"
          ><div
            @click="GetTodayProject(one, year,month,seven,1)"
            class=""
          >
            {{ seven }}
          </div></el-col
        >
      </el-row>

      <el-row
        style="font-size: 14px; color: rgba(40, 40, 40, 1); magin-bottom: 20px"
      >
        <el-col :sm="2" class="border_left"> <div>08:00</div></el-col>
        <el-col :sm="2" class="border_left"><div>09:00</div></el-col>
        <el-col :sm="2" class="border_left"><div>10:00</div></el-col>
        <el-col :sm="2" class="border_left"><div>11:00</div></el-col>
        <el-col :sm="2" class="border_left"><div>12:00</div></el-col>
        <el-col :sm="2" class="border_left"><div>13:00</div></el-col>
        <el-col :sm="2" class="border_left"><div>14:00</div></el-col>
        <el-col :sm="2" class="border_left"><div>15:00</div></el-col>
        <el-col :sm="2" class="border_left"><div>16:00</div></el-col>
        <el-col :sm="2" class="border_left"><div>17:00</div></el-col>
        <el-col :sm="2" class="border_left"><div>18:00</div></el-col>
        <el-col :sm="2" class="border_left"><div>19:00</div></el-col>
      </el-row>

      <el-row
        style="font-size: 14px; color: rgba(40, 40, 40, 1); margin-bottom: 0px"
        v-for="(itemList, jj) in GetTodayProjectList"
        :key="jj"
      >
        <el-col
          v-for="(item, index) in itemList"
          :key="index"
          :sm="2"
          class="border_left"
        >
          <div
            v-if="item != '-'"
            :class="
              jj == 0
                ? 'one'
                : jj == 1
                ? 'two'
                : jj == 2
                ? 'three'
                : jj == 3
                ? 'four'
                : jj == 4
                ? 'five'
                : jj == 5
                ? 'six'
                : 'seven'
            "
          >
            {{ item }}
          </div>
          <div v-else></div>
        </el-col>
      </el-row>
    </el-main>
    <el-footer style="height: 25%;margin-top: 15px;padding-right: 20px;background: rgba(255, 255, 255, 1);min-height: 200px;">
      <el-row style="height: 100%;color: rgba(0, 136, 255, 1);text-align: center;font-size: 16px;color: rgba(40, 40, 40, 1);">
        <el-col :sm="18" style="height: 100%">
          <el-col style=" text-align: left; font-size: 18px; color: rgba(40, 40, 40, 1); margin-top: 10px;">
            <h3>工时统计</h3>
          </el-col>
          <el-col :sm="24" style="text-align: left; margin-top: 1%;">
            <el-col :sm="6" style="rgba(40, 40, 40, 1)">本月排班：{{ SchedulingMonth }}h </el-col>
            <el-col :sm="6" style="">咨询时长：{{ consultTime }}h </el-col>
            <el-col :sm="6" style="">坐班时长：{{ working }}h </el-col>
            <el-col :sm="6" style="">请假时长：{{ leave }}h </el-col>
          </el-col>
          <el-col :sm="24" style="text-align: left; margin-top: 1%; width: 80%">咨询排班占比
            <div style="width: 80%; margin-top: 1%;">
              <el-progress :text-inside="true" :stroke-width="26"  :percentage="proportion"></el-progress>
            </div>
          </el-col>
        </el-col>

        <el-col :sm="1" style="background: rgba(239, 239, 239, 1);width:15px;height:100%">
        </el-col>

        <el-col :sm="5" style="margin-left: 20px; height: 100%;">
          <ul class="ConsultantWork_rul">
            <li @click="xshio('/Consultant/AppointmentList')">
              <div class="el-icon-tickets">
                <i>{{ReservationTodoSummary}}</i>
              </div>
              <p>咨询预约</p>
            </li>

            <li @click="xshio('/Crisis/Crisis_upreport')">
              <div class="el-icon-data-analysis" style="background: linear-gradient(90deg,rgba(40, 181, 115, 1) 0%,rgba(77, 191, 138, 1) 100%);">
                <i>{{CrisisReportTodoSummary}}</i>
              </div>
              <p>危机上报</p>
            </li>

            <li @click="xshio('/Crisis/Crisis_Intervent')">
              <div class="el-icon-first-aid-kit" style="background: linear-gradient(135deg,rgba(120, 139, 231, 1) 0%,rgba(92, 114, 226, 1) 100%);">
                <i>{{CrisisInterveneTodoSummary}}</i>
              </div>
              <p>危机干预</p>
            </li>
          </ul>
          <!-- <div @click="xshio()" style="height: 80%;">
            <div style="text-align: left;font-size: 18px;color: rgba(40, 40, 40, 1);margin-top: 10px;">
              <h3>待办任务</h3>
            </div>

            <div style="position: relative;height: 55px;">
              <span style="position: absolute;top:30px;left: 20px;">咨询预约待办数量</span>
              <el-badge style="font-size: 50px;color: rgba(242, 158, 0, 1);position: absolute;top:20px;left: 180px;" :value="ReservationTodoSummary" class="item el-icon-s-order" type="primary">
              </el-badge>
            </div>

            <div style="position: relative;height: 55px;">
              <span style="position: absolute;top:30px;left: 20px;">危机上报待办数数量</span>

              <el-badge style="font-size: 50px;color: rgba(242, 158, 0, 1);position: absolute;top:20px;left: 180px;" :value="CrisisReportTodoSummary" class="item el-icon-s-order" type="primary">
              </el-badge>
            </div>

            <div style="position: relative;height: 55px;">
              <span style="position: absolute;top:30px;left: 20px;">危机干预待办数量</span>
              <el-badge style="font-size: 50px;color: rgba(242, 158, 0, 1);position: absolute;top:20px;left: 180px;" :value="CrisisInterveneTodoSummary" class="item el-icon-s-order" type="primary">
              </el-badge>
            </div> 
          </div> -->
        </el-col>
      </el-row>
    </el-footer>
  </el-container>
</template>
<script>
export default {
  mounted() {
    var date = new Date();
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    this.year = year;
    this.month = month;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }

    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }

    var a = new Date();
    a.setDate(a.getDate() + 1);
    this.dateTimeNow = year + "年" + month + "月" + strDate + "日";
    this.one = strDate;
    this.two = (a.getDate()).toLocaleString();
    this.three = (a.getDate() + 1).toLocaleString();
    this.four = (a.getDate() + 2).toLocaleString();
    this.five = (a.getDate() + 3).toLocaleString();
    this.six = (a.getDate() + 4).toLocaleString();
    this.seven = (a.getDate() + 5).toLocaleString();
    this.today = strDate;
    this.GetList();
    this.GetTodayProject(this.one, this.year, this.month ,this.one,2);
    this.GetMonthConsulting();
  },
  data() {
    return {
      CrisisInterveneTodoSummary:'',
      CrisisReportTodoSummary:'',
      ReservationTodoSummary:'',
      year: "",
      month: "",
      dateTimeNow: "",//当前时间内
      one: "",
      two: "",
      three: "",
      four: "",
      five: "",
      six: "",
      seven: "",
      today: "",
      AppointmentCount: 0,
      todayCount: 0,
      examineCount: 0,
      applycount: 0,
      passCount: 0,
      noPassCount: 0,
      SchedulingMonth: 0,
      consultTime: 0,
      working: 0,
      leave: 0,
      proportion: 0,
      GetTodayProjectList: [],
      timeList: [
        "08:00",
        "09:00",
        "10:00",
        "11:00",
        "12:00",
        "13:00",
        "14:00",
        "15:00",
        "16:00",
        "17:00",
        "18:00",
        "19:00",
      ],
    };
  },
  methods: {
    xshio(val) {
      this.$router.push(val);
      // this.$router.push('/Consultant/AppointmentList');
    },
    GetMonthConsulting() {
      this.$Http_Post("ConsultSubscribe/GetMonthConsulting", {}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          let date = res.Data;
          this.SchedulingMonth = date.SchedulingMonth;
          this.consultTime = date.consultTime;
          this.working = date.working;
          this.leave = date.leave;
          this.proportion = date.proportion.toFixed(2);
        } else {
          this.Global.request_failure(res.Message)
        }
      });
    },
    GetTodayProject(one,year, month, day,pd) {
      if (day != undefined && day != null) {
        this.today = day;
      }

      // if (pd == 2) {
      //   this.$Http_Post("ConsultSubscribe/GetTodayProject", {
      //     Time: year + '-' + month + '-' + day,
      //   }).then((res) => {
      //     if (res.Code == 200 || res.Code == 0) {
      //       this.GetTodayProjectList = res.Data;
      //     } else {
      //       this.$message({
      //         type: "success",
      //         message: "数据加载异常！",
      //       });
      //     }
      //   });
      // } else {

      if (one < day) {
          this.$Http_Post("ConsultSubscribe/GetTodayProject", {
            Time: year + '-' + month + '-' + day,
          }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.GetTodayProjectList = res.Data;
            } else {
              this.$message({
                type: "success",
                message: "数据加载异常！",
              });
            }
          });

        } else {
          this.$Http_Post("ConsultSubscribe/GetTodayProject", {
          Time: year + '-' + month + '-' + day,
          }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.GetTodayProjectList = res.Data;
            } else {
              this.$message({
                type: "success",
                message: "数据加载异常！",
              });
            }
          });
        }
        
      // }

      
    },

    GetDateStr(AddDayCount) {
      var dd = new Date();
      dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1; //获取当前月份的日期
      var d = dd.getDate();
      return y + "-" + m + "-" + d;
    },

    GetList() {
      this.$Http_Post("ConsultSubscribe/GetCalendarList", {}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          var data = res.Data;
          this.AppointmentCount = data.AppointmentCount;
          this.todayCount = data.todayCount;
          this.examineCount = data.examineCount;
          this.applycount = data.applycount;
          this.passCount = data.passCount;
          this.noPassCount = data.noPassCount;
        } else {
          this.$message({
            type: "success",
            message: "数据加载异常！",
          });
        }
      });

      this.$Http_Post("/ConsultSubscribe/GetTodoList", {}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.CrisisInterveneTodoSummary = res.Data.CrisisInterveneTodoSummary;
          this.CrisisReportTodoSummary = res.Data.CrisisReportTodoSummary;
          this.ReservationTodoSummary = res.Data.ReservationTodoSummary;
        } else {
          this.$message({
            type: "success",
            message: "数据加载异常！",
          });
        }
      });
    },
  },
};
</script>
<style>
.border_left {
  border-radius: 0px;
  border-left: 1px solid rgb(227, 225, 225);
}
.border_left div {
  height: 30px;
  width: 100%;
}
.checked {
  background-color: rgba(0, 136, 255, 1);
  color: white;
}
.timerow div {
  padding: 5px;
  cursor: pointer;
}
.workingSchedule .one {
  /*未预约*/
  line-height: 30px;
  text-align: center;
  background: linear-gradient(
    90deg,
    rgb(137, 143, 148) 0%,
    rgba(138, 202, 255, 1) 100%
  );
  border-radius: 22px;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
}

.workingSchedule .two {
  /*已预约*/
  line-height: 30px;
  text-align: center;
  background: linear-gradient(
    90deg,
    rgba(28, 153, 255, 1) 0%,
    rgba(138, 202, 255, 1) 100%
  );
  border-radius: 22px;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
}
.workingSchedule .three {
  /*来访者取消*/
  line-height: 30px;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  background: linear-gradient(
    90deg,
    rgba(242, 75, 78, 1) 0%,
    rgba(237, 140, 142, 1) 100%
  );
  border-radius: 22px;
  mix-blend-mode: normal;
}
.workingSchedule .four {
  /*咨询师取消*/
  line-height: 30px;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  background: linear-gradient(
    90deg,
    rgba(255, 141, 26, 1) 0%,
    rgba(247, 184, 121, 1) 100%
  );
  border-radius: 22px;
  mix-blend-mode: normal;
}
.workingSchedule .five {
  /*未来访*/

  line-height: 30px;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;

  background: linear-gradient(
    90deg,
    rgb(65, 58, 52) 0%,
    rgba(247, 184, 121, 1) 100%
  );
  border-radius: 22px;
  mix-blend-mode: normal;
}
.workingSchedule .six {
  /*已来访*/
  line-height: 30px;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  background: linear-gradient(
    90deg,
    rgb(120, 223, 89) 0%,
    rgb(40, 202, 88) 100%
  );
  border-radius: 22px;
  mix-blend-mode: normal;
}
.workingSchedule .seven {
  /*空班*/
  line-height: 30px;
  text-align: center;
  background: linear-gradient(
    90deg,
    rgba(74, 186, 132, 1) 0%,
    rgba(74, 186, 132, 0.8) 100%
  );
  border-radius: 22px;
  mix-blend-mode: normal;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
}


.el-progress-bar__innerText{color: #000;}
.ConsultantWork_rul li{width: 49.5%;
    float: left;
    height: 90px;
    text-align: center;
    margin: auto;
    cursor: pointer;}

  .ConsultantWork_rul li div{
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg,rgba(255, 195, 80, 1) 0%,rgba(242, 158, 0, 1) 100%);
    border-radius: 8px;
    mix-blend-mode: normal;
    font-size: 26px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    position: relative;
    margin-top: 14px;
  }
  .ConsultantWork_rul li i{
position: absolute;
    top: -10px;
    right: -10px;
    background-color: red;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    font-size: 12px;
    line-height: 20px;
  }

</style>
